export const tableHeaderData_Desktop = [
  { label: "Date Created", cellWidth: "226px" },
  { label: "Product Name", cellWidth: "228px" },
  { label: "Amount", cellWidth: "155px" },
  { label: "Payment type", cellWidth: "133px" },
  { label: "Transaction ID", cellWidth: "160px" },
  { label: "Status", cellWidth: "160px" },
  { label: "", cellWidth: "57px" },
];

export const tableHeaderData_Mobile = [
  { label: "Date Created", cellWidth: "226px" },
  { label: "Product Name", cellWidth: "228px" },
];

export const TableBodyData = [
  {
    dateCreated: "",
    productName: "",
    amount: "",
    status: "",
    qRCode: "",
    button1: "",
    button2: "",
  },
  // {
  //   dateCreated: "date-created",
  //   productName: "hair",
  //   amount: "$200",
  //   status: "Pending",
  //   qRCode: "code",
  //   button1: "button1",
  //   button2: "button2",
  // },
  // {
  //   dateCreated: "date-created",
  //   productName: "hair",
  //   amount: "$200",
  //   status: "Pending",
  //   qRCode: "code",
  //   button1: "button1",
  //   button2: "button2",
  // },
  // {
  //   dateCreated: "date-created",
  //   productName: "hair",
  //   amount: "$200",
  //   status: "Pending",
  //   qRCode: "code",
  //   button1: "button1",
  //   button2: "button2",
  // },
];

// export const TableBodyData = []
